import { StyleSheet } from "aphrodite";
import COLORS from "../../../../library/colors";

const Color = require("color");

const styles = StyleSheet.create({
  root: {
    borderRadius: 4,
    height: 48,
    background: COLORS.kgGreen,
    color: `${Color(COLORS.kgGreen).darken(0.64)}`,
    border: "none",
    ":hover": {
      background: `${Color(COLORS.kgGreen).lighten(0.08)}`,
      color: `${Color(COLORS.kgGreen).darken(0.48)}`,
      border: "none",
      cursor: "pointer"
    },
    ":active": {
      background: `${Color(COLORS.kgGreen).lighten(0.12)}`,
      border: "none"
    }
  },
  rootLoading: {
    color: "gray",
    paddingTop: 12,
    background: `${Color(COLORS.kgGreen).lighten(0.12)}`,
    ":hover": {
      background: `${Color(COLORS.kgGreen).lighten(0.12)}`,
      border: "none",
      cursor: "default"
    }
  },
  rootDisabled: {
    background: "#e6e6e6",
    color: "#c5c5c5",
    ":hover": {
      background: "#e6e6e6",
      color: "#c5c5c5",
      border: "none",
      cursor: "default"
    }
  },
  normalHeightButton: {
    height: 32
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/button/filled-green-button/filled-green-button-styles.js